/**
 * The tag that says where an email order came from.
 *
 * Every one of these was parsed out of a partner's order email, and the same
 * order is usually live on that partner's own screen too. Naming the system it
 * came from is what answers "is this the one on the other tablet?" — the
 * question a plain envelope icon never could.
 *
 * Only MenuSifu has a mark of its own so far. Anything else — eDiningExpress,
 * OTHER, or an order whose merchant was never linked and so carries no provider
 * at all — keeps the envelope. A missing provider must never render as a brand
 * we guessed at.
 *
 * Same rule and words as EmailSourceBadge in the restaurant tablet app. The
 * colour is the Orders page's neutral source-tag style (see OpsUi Tag), so
 * source never competes with the status colours.
 */
import React from 'react'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import menusifuLogo from '../../assets/img/menusifu-logo.png'
import { Tag } from './OpsUi'

const EmailSourceChip = ({ provider, label = 'Email order', sx = {} }) => {
  const isMenuSifu = String(provider || '').toUpperCase() === 'MENUSIFU'

  return (
    <Tag
      sx={sx}
      icon={
        isMenuSifu ? (
          <img
            src={menusifuLogo}
            alt="MenuSifu"
            style={{ width: 14, height: 14, borderRadius: 3, objectFit: 'contain' }}
          />
        ) : (
          <MailOutlineIcon />
        )
      }
    >
      {label}
    </Tag>
  )
}

export default EmailSourceChip
